import { createContext, useContext, useMemo, useState } from 'react';
import resumeRu from '../data/resume.json';
import resumeEn from '../data/resume_en.json';
import { UI } from './ui';

const LocaleContext = createContext(null);

const RESUME = {
  ru: resumeRu,
  en: resumeEn,
};

export const LocaleProvider = ({ children }) => {
  const [lang, setLang] = useState('ru');

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: UI[lang],
      resumeData: RESUME[lang],
    }),
    [lang]
  );

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
};

export const useLocale = () => {
  const ctx = useContext(LocaleContext);
  if (!ctx) {
    throw new Error('useLocale must be used within LocaleProvider');
  }
  return ctx;
};
